export default "__VITE_ASSET__DdX$UjQC__"